import { Box } from "@mui/material";
import SearchBar from "Components/shared/SearchBar";
import CustomButton from "Components/shared/Button";
import { useRTL } from "hooks/isRTL";
import { useAtom } from "jotai";
import {
  driverPageAtom,
  driverRequestsFiltersAtom,
} from "./atoms/driverRequestsFiltersAtom";

const DriverRequestsSearch = () => {
  const [filters, setFilters] = useAtom(driverRequestsFiltersAtom);
  const [, setPage] = useAtom(driverPageAtom);
  const { t } = useRTL();

  const updateFilters = (newFilters) => {
    setFilters((prev) => ({ ...prev, ...newFilters }));
  };

  const handleSearchChange = (searchValue) => {
    updateFilters({ searchBar: searchValue });
  };

  const handleClearFilters = () => {
    const clearedFilters = {
      searchBar: "",
      status: null,
      descendingCreationDateSort: null,
    };
    setFilters(clearedFilters);
    setPage(0);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "16px",
        borderRadius: "8px",
        marginBottom: "5px",
        backgroundColor: "white",
        padding: "16px",
      }}
    >
      <Box sx={{ flex: 1, maxWidth: "350px" }}>
        <SearchBar
          value={filters.searchBar}
          onSearch={handleSearchChange}
          placeholder={t("searchByOrderId")}
        />
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <CustomButton onClick={handleClearFilters}>
          {t("clearFilters")}
        </CustomButton>
      </Box>
    </Box>
  );
};

export default DriverRequestsSearch;
